import PCLNExpt from './components/common/pcln-expt'
import { isBrowser } from './components/utils/generic-utilities'

const pclnExpt = new PCLNExpt()

const isAngular1 = () => {
  return isBrowser() && typeof window.angular !== 'undefined' && window.angular.version.major === 1
}

if (isBrowser() && isAngular1()) {
  // provider is needed to allow, for example, initialization as seen in m-stay
  window.angular.module('pcln-experimentation', []).provider('PCLNExpt', [
    function () {
      this.initialize = pclnExpt.initialize.bind(pclnExpt)
      this.getTestState = pclnExpt.getTestState.bind(pclnExpt)
      this.isDefault = pclnExpt.isDefault.bind(pclnExpt)
      this.isVariant = pclnExpt.isVariant.bind(pclnExpt)
      this.fireImpression = pclnExpt.fireImpression.bind(pclnExpt)
      this.fireEvent = pclnExpt.fireEvent.bind(pclnExpt)
      this.$get = () => pclnExpt
    },
  ])
}

export { PCLNExpt }
export default pclnExpt
